import {
  ClosedDatesViewWidget,
  ClosedDatesWidget,
  DateRangesViewWidget,
  DateRangesWidget,
  ObjectListViewWidget,
  OptionsViewWidget,
  OptionsWidget,
  OrderingTimetableViewWidget,
  OrderingTimetableWidget,
  TimetableViewWidget,
  TimetableWidget,
} from '../components';

export const widgetMapping = {
  widget: {
    closed_dates_widget: ClosedDatesWidget,
    dateranges_widget: DateRangesWidget,
    options_widget: OptionsWidget,
    ordering_timetable_widget: OrderingTimetableWidget,
    timetable_widget: TimetableWidget,
  },
  views: {
    widget: {
      closed_dates_widget: ClosedDatesViewWidget,
      dateranges_widget: DateRangesViewWidget,
      object_list: ObjectListViewWidget,
      options_widget: OptionsViewWidget,
      ordering_timetable_widget: OrderingTimetableViewWidget,
      timetable_widget: TimetableViewWidget,
    },
  },
};
